import { Router } from '@angular/router';
import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';

import * as fromRoot from '../reducers';
import { constants } from '../constants';

@Injectable()
export class BrowserUtils {
	constructor(private readonly store: Store<fromRoot.AppState>, private readonly router: Router) { }

	public getDevice() {
		const isAndroid = navigator.userAgent.toLowerCase().match(/android/i),
			isiPhone = navigator.userAgent.toLowerCase().match(/iphone/i),
			isiPad = navigator.userAgent.toLowerCase().match(/ipad/i);

		if (isAndroid) {
			return constants.DEVICE_TYPE.ANDROID;
		}
		if (isiPhone) {
			return constants.DEVICE_TYPE.IPHONE;
		}
		if (isiPad) {
			return constants.DEVICE_TYPE.IPAD;
		} else {
			return constants.DEVICE_TYPE.DESKTOP;
		}
	}

	public openInNewTab(namedRoute: string) {
		const newRelativeUrl = this.router.createUrlTree([namedRoute]);
		const baseUrl = window.location.href.replace(this.router.url, '');

		window.open(baseUrl + newRelativeUrl, '_blank');
	}

	public getOS() {
		const isMac = navigator.userAgent.toUpperCase().indexOf('MAC') >= 0;
		return isMac ? constants.OS_TYPE.IOS : constants.OS_TYPE.ANDROID;
	}
}
